// ============================================
// 2026-09-14｜组合模型小部件操作（阶段 A+B）：
// - 右键上下文菜单状态（视口/树共用）
// - 小部件剪贴板（复制/剪切/软删除恢复）
// ============================================

import { create } from 'zustand';

export interface SubObjectMenuState {
  /** 菜单打开状态与锚点（屏幕坐标，fixed 定位） */
  menu: { x: number; y: number; modelId: string; uuid: string; name: string } | null;
  /** 重命名弹窗目标（右键菜单"重命名"/F2 共用） */
  renameTarget: { modelId: string; uuid: string; name: string } | null;
  openMenu: (payload: { x: number; y: number; modelId: string; uuid: string; name: string }) => void;
  closeMenu: () => void;
  openRename: (target: { modelId: string; uuid: string; name: string }) => void;
  closeRename: () => void;
}

export const useSubObjectMenuStore = create<SubObjectMenuState>((set) => ({
  menu: null,
  renameTarget: null,
  openMenu: (payload) => set({ menu: payload }),
  closeMenu: () => set({ menu: null }),
  openRename: (target) => set({ renameTarget: target, menu: null }),
  closeRename: () => set({ renameTarget: null }),
}));

// --------------------------------------------
// 小部件剪贴板（模块级，非响应式）
// 操作语义（本轮）：
// - copy：选中部件克隆一份（原位微偏移），剪贴板记录源（可继续粘贴生成更多副本）
// - cut：选中部件软隐藏（visible=false，可撤销/粘贴恢复）；剪贴板记录
// - delete：软隐藏（同 cut，可 Ctrl+V 恢复）
// 软隐藏的可见性已由 SubObjectConfig.visible 持久化（保存刷新天然保持）
// --------------------------------------------
export interface SubObjectClipboard {
  op: 'copy' | 'cut';
  modelId: string;
  uuid: string;
  name: string;
}

let clipboard: SubObjectClipboard | null = null;

export function setSubObjectClipboard(v: SubObjectClipboard | null) {
  clipboard = v;
}

export function getSubObjectClipboard(): SubObjectClipboard | null {
  return clipboard;
}
